module.exports = __webpack_public_path__ + "static/media/reactlogo.48390e18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reactlogo.svg
// module id = 179
// module chunks = 4